;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    dataList: Array,
    filename: String
  },
  computed: {
    uri: function uri() {
      if (this.dataList.length < 1) {
        return "#";
      }
      var csvString = this.buildCsvString();
      csvString = "data:text/csv;charset=utf-8," + csvString;
      return csvString;
    }
  },
  methods: {
    buildCsvString: function buildCsvString() {
      var _this = this;

      var result = "";
      var columnDelimiter = ",";
      var lineDelimiter = "\n";
      var cols = (0, _keys2.default)(this.dataList[0]).sort(function (a, b) {
        a = parseInt(a.split(".")[0]) || 0;
        b = parseInt(b.split(".")[0]) || 0;

        return a - b;
      });

      var headers = cols.map(function (col) {
        return _this.removeOrdering(col);
      });

      result += headers.join(columnDelimiter);
      result += encodeURI(lineDelimiter);

      this.dataList.forEach(function (row) {
        cols.forEach(function (col) {
          result += ("" + (encodeURIComponent(row[col]) || "null")).replace(/,/g, " ") + columnDelimiter;
        });
        result += encodeURI(lineDelimiter);
      });
      return result;
    },
    removeOrdering: function removeOrdering(col) {
      var colNum = parseInt(col.split(".")[0]) || null;

      if (colNum) {
        colNum = colNum + ".";
        var index = col.indexOf(colNum);

        col = col.slice(0, index) + col.slice(index + colNum.length);
        return col.trim();
      } else {
        return col;
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.uri,"download":this.uri == '#' ? false : _vm.filename || 'data.csv'}},[_vm._t("default")],2)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-aa258560", __vue__options__)
  } else {
    hotAPI.reload("data-v-aa258560", __vue__options__)
  }
})()}